import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DivColumn, DivRow, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsImages from "../../../constants/ConstantsImages";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import ApiService from "../../../data/ApiService";
import UtilsUnit from "../../../utils/UtilsUnit";
import WidgetIconFive from "../../icons/widget-icon-five/WidgetIconFive";
import "./WidgetAlertDialogPendingRequests.css";

const WidgetAlertDialogPendingRequests = ({ onClose }) => {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadRequests = async () => {
      const data = await ApiService.getPendingChangeRequests();
      if (isMounted) {
        setRequests(data);
      }
    };

    loadRequests();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleRequestClick = (request) => {
    if (!request?.requestedTerminalID) {
      return;
    }

    onClose?.();
    UtilsUnit.handleNavigateToTerminalInfo(navigate, false, request.requestedTerminalID, request);
  };

  return (
    <div className="alert-dialog-pending-requests-overlay" onClick={onClose}>
      <DivColumn className="alert-dialog-pending-requests" onClick={(event) => event.stopPropagation()}>
        <DivRow className="alert-dialog-pending-requests-close-row">
          <button type="button" className="alert-dialog-pending-requests-close" onClick={onClose} aria-label="סגירה">
            <WidgetIconFive iconProp={ConstantsImages.PENDING_REQUESTS_CLOSE_IMAGE} widthIconProp="1rem" heightIconProp="1rem" />
          </button>
        </DivRow>

        <ParagraphText className="alert-dialog-pending-requests-title">{ConstantsTexts.CODE_255}</ParagraphText>

        <DivColumn className="alert-dialog-pending-requests-table">
          <DivRow className="alert-dialog-pending-requests-header">
            <ParagraphText className="alert-dialog-pending-requests-header-text alert-dialog-pending-requests-col-name">
              {ConstantsTexts.CODE_258}
            </ParagraphText>
            <ParagraphText className="alert-dialog-pending-requests-header-text alert-dialog-pending-requests-col-sku">
              {ConstantsTexts.CODE_257}
            </ParagraphText>
            <ParagraphText className="alert-dialog-pending-requests-header-text alert-dialog-pending-requests-col-requester">
              {ConstantsTexts.CODE_256}
            </ParagraphText>
          </DivRow>

          {requests.map((request) => (
            <button
              type="button"
              key={request.requestID}
              className="alert-dialog-pending-requests-row"
              onClick={() => handleRequestClick(request)}
            >
              <ParagraphText className="alert-dialog-pending-requests-cell alert-dialog-pending-requests-col-name">
                {request.terminalName}
              </ParagraphText>
              <ParagraphText className="alert-dialog-pending-requests-cell alert-dialog-pending-requests-col-sku">
                {request.erezSKU}
              </ParagraphText>
              <ParagraphText className="alert-dialog-pending-requests-cell alert-dialog-pending-requests-col-requester">
                {request.requestedByUserName}
              </ParagraphText>
            </button>
          ))}
        </DivColumn>
      </DivColumn>
    </div>
  );
};

export default WidgetAlertDialogPendingRequests;
